import React from 'react';
import { StyledLabelWithUIGuidelines } from './styles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

type TProps = {
  label: string;
  required?: boolean;
  margin?: string;
};

export const LabelWithUIGuidelines = ({ label, required, margin }: TProps) => {
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <StyledLabelWithUIGuidelines isMobile={isMobile} margin={margin}>
      {label}
      {required && '*'}
    </StyledLabelWithUIGuidelines>
  );
};
